<template>
  <div class="navag">
    <ul>
        <li><router-link to="/"><span>首页</span></router-link></li>
        <li><router-link :to="{ path: '/filling',query:{id:0,isTop:1}}"><span>创新实干加油站</span></router-link></li>
        <li><router-link :to="{ path: '/filling',query:{id:1,isTop:1}}"><span>智慧礼堂靓舞台</span></router-link></li>
        <li><router-link to="/gardener"><span>我是畲乡小园丁</span></router-link></li>
        <li><router-link :to="{ path: '/filling',query:{id:2,isTop:1}}"><span>服务群众担使命</span></router-link></li>
        <li><router-link :to="{ path: '/filling',query:{id:3,isTop:1}}"><span>美丽文明新畲乡</span></router-link></li>
    </ul>
  </div>
</template>

<script>
import api from '../assets/config/api'
import axios from 'axios'
export default {
  name: 'navag',
  data() {
    return {
    }
  },
  components: {
    
  },
  async mounted() {
    // await axios.post(api.carImg, {
    //     col_id:140
    // })
    // .then(response => {
    //     console.log(response);
    // })
    // .catch(function (error) {
    //     console.log(error);
    // });
  },
}
</script>
<style lang="less" scoped>
    .navag{
        width: 1200px;
        margin: 0 auto;
        background: #fff url(../assets/images/navTitle.png) no-repeat 0;
        ul{
            overflow: hidden;
            padding-left: 600px;
            li{
                float: left;
                a{
                    width: 80px;
                    height: 130px;
                    line-height: 130px;
                    display: inline-block;
                    text-align: center;
                    padding: 0 10px;
                    font-size: 18px;
                    &.router-link-exact-active{
                        background: url(../assets/images/navag.png) no-repeat;
                        color: #fff;
                    }
                    span{
                        vertical-align: middle;
                        display: inline-block;
                        line-height: 24px;
                    }
                }
            }
        }
    }
</style>